import React, { Component } from 'react';
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        });

    }
    render() {
        if (this.state.error) {
            return (
                <div>
                    <h2>Something went wrong.Please try again later</h2>
                </div>
            );
        } else { return this.props.children; }


    }
}

export default ErrorBoundary;